module.exports = __webpack_public_path__ + "img/30_57.5cd1af12.png";